import { map } from 'rxjs/operators';
import { Component } from '@angular/core';
import { AngularTokenService } from '@lakshvairav/angular-token';
import { Router } from '@angular/router';
import { KeyValue } from '../../shared/key-value';
import { AuthorizationService } from '../../shared/authorization.service';
// import { NguiPopupComponent, NguiMessagePopupComponent } from '@ngui/popup';
@Component({
  selector: 'admin-add-economy',
  templateUrl: 'admin-add-economy.component.html'
})
export class AdminAddEconomyComponent {
  economy_sequences: any = [];
  // admin_sequences: any [];
  new_economy: any;
  eseq_values_error: any;
  economy_saved: any = [];
  user_id: any;
  econ_added: any = [];
  // default_sequences: any = [];
  // @ViewChild(NguiPopupComponent) popup: NguiPopupComponent;
  constructor(private router: Router, private _tokenService: AngularTokenService,
    private KeyValueService: KeyValue, public authService: AuthorizationService) {
  }

  getEconomies() {
    this.authService.get(KeyValue.api_add_economy).pipe(
      map(res => res)).subscribe(
        data => {
          this.set_values(data);
        },
        error => {
          console.log(error);
        }
      );
  }

  save_economy(index) {
    this.economy_saved[index] = true;
    this.authService.post(KeyValue.api_add_economy, { economy_attributes: this.economy_sequences[index] }).pipe(
      map(res => res)).subscribe(
        data => {
          if (data.status === 200) {
            this.set_values(data);
            KeyValue.flash_msg_update({ msg: data.message, type: 'success_messages' });
            this.economy_saved[index] = false;
          } else {
            // KeyValue.flash_msg_update({msg: data.message, type: 'error_messages'});
            this.map_errors(index, this.eseq_values_error, data.errors.eseq_values);
            KeyValue.flash_msg_update({ msg: KeyValue.decision_form_error, type: 'error_messages' });
            this.economy_saved[index] = false;
          }
        },
        error => {
          console.log('in... api failure' + error);
        }
      );
  }

  map_errors(index, obj, errors): void {
    for (let _i = 0; _i < errors.length; _i++) {
      obj[index][_i] = errors[_i].split(',');
    }
  }

  fill_map_errors(count): any {
    const obj = [];
    for (let j = 0; j < count; j++) {
      obj[j] = [];
      for (let _i = 0; _i < count; _i++) {
        obj[j].push([]);
      }
    }
    return obj;
  }

  check_economy_length() {
    return this.economy_sequences.length < 40;
  }

  remove_economy(index) {
    this.economy_sequences.splice(index, 1);
    this.eseq_values_error = this.fill_map_errors(40);
    this.econ_added = [];
    console.log(this.econ_added, "econadded")
  }

  delete(index) {
    if (this.economy_sequences[index].id === undefined) {
      this.remove_economy(index);
    } else {
      this.openPopup(index);
    }
  }

  delete_economy(index) {
    this.authService.post(KeyValue.api_economy_destroy, { economy_attributes: this.economy_sequences[index] }).pipe(
      map(res => res)).subscribe(
        data => {
          if (data.status === 200) {
            this.set_values(data);
            KeyValue.flash_msg_update({ msg: data.message, type: 'success_messages' });
          } else {
            KeyValue.flash_msg_update({ msg: data.message, type: 'error_messages' });
          }
        },
        error => {
          console.log('in... api failure' + error);
        }
      );
  }

  set_values(data) {
    this.economy_sequences = data.economy_sequences;
    this.eseq_values_error = this.fill_map_errors(40);
    this.econ_added = data.economy_sequences.filter(econ => econ.user_id === this.user_id);
  }

  addNewEconomy() {

    const temp_hash = {
      name: parseInt(this.economy_sequences[this.economy_sequences.length - 1].name) + 1,
      note: '',
      created_by: 'user',
      eseq_values_attributes: this.assign_eseq_values()
    };
    this.economy_sequences.push(temp_hash);
    this.eseq_values_error = this.fill_map_errors(40);
    this.econ_added = this.economy_sequences[this.economy_sequences.length - 1];
    console.log(this.econ_added, "econadded")
  }

  assign_eseq_values() {
    const e_value = [];
    for (let i = 0; i < 40; i += 1) {
      if (this.check_dec_index(i)) {
        e_value.push({ econ_value: this.economy_sequences[0].eseq_values_attributes[i].econ_value });
      } else {
        e_value.push({ econ_value: '' });
      }
    }
    return e_value;
  }

  redirectToSessionControl() {
    this.router.navigate([this.authService.getChangePath(KeyValue.insControlsPath)]);
  }

  ngOnInit() {
    // this.user_id = this._tokenService.currentUserData.id;
    this.user_id = this.authService.getID();
    this.getEconomies();
    this.eseq_values_error = this.fill_map_errors(40);
  }

  private getFocusableElements(modal: HTMLElement): HTMLElement[] {
    return Array.from(
      modal.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )
    ) as HTMLElement[];
  }

  private trapFocus(modal: HTMLElement): void {
    const focusableElements = this.getFocusableElements(modal);
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];
  
    // Focus the first element
    firstFocusableElement.focus();
  
    // Add event listener for Tab key
    modal.addEventListener('keydown', (event: KeyboardEvent) => {
      if (event.key === 'Tab') {
        if (event.shiftKey) {
          // Shift + Tab: Move focus backward
          if (document.activeElement === firstFocusableElement) {
            event.preventDefault();
            lastFocusableElement.focus();
          }
        } else {
          // Tab: Move focus forward
          if (document.activeElement === lastFocusableElement) {
            event.preventDefault();
            firstFocusableElement.focus();
          }
        }
      }
    });
  }

  openPopup(index) {
    const customPopup = document.getElementById('customPopup');
    customPopup.style.display = 'flex';
    this.trapFocus(customPopup);

    function closePopup() {
      customPopup.style.display = 'none';
    }

    // Handle the "OK" button click
    const deleteButton = document.getElementById('deleteButton');
    deleteButton.addEventListener('click', () => {
      this.delete_economy(index);
      closePopup();
    });

    // Handle the "Cancel" and "Close" button clicks
    const cancelButton = document.getElementById('cancelButton');
    const closeButton = document.getElementById('closeButton');
    cancelButton.addEventListener('click', closePopup);
    closeButton.addEventListener('click', closePopup);
  }

  check_dec_index(index) {
    if (index < 12 || index > 29) {
      return true;
    } else {
      return false;
    }
  }

  add_default_values(obj) {
    for (let _i = 0; _i < obj.length; _i++) {
      if (this.check_dec_index(_i)) {
        obj[_i].econ_value = 1;
      }
    }
  }

  is_default_economy(economy) {
    return economy.created_by === 'user' && (this.user_id === economy.user_id || economy.user_id == null);
  }

  viewEconomyPDF(economy) {
    if (economy && economy.name) {
      const pdf_path = KeyValue.api_economy_pdf + '?name=' + economy.name;
      // Use AuthorizationService to make the GET request with auth headers and expect a blob
      this.authService.get(pdf_path, { responseType: 'blob' }).subscribe(data => {
        const url = window.URL.createObjectURL(data);
        window.open(url, '_blank');
        setTimeout(() => window.URL.revokeObjectURL(url), 1000);
      });
    }
  }

}